export default __webpack_public_path__ + "static/media/empresa.fca7fd9c.png";